/* eslint-disable max-len, @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useState, useEffect } from 'react'
import '../../asserts/css/custom.css'
import { useParams } from 'react-router-dom'
import minijust_logo from '../../assets/img/minijust_logo.png'
import InstitutionUserService from '../../services/InstitutionUserService'
import {
  Button,
  Card,
  Col,
  Row,
  Form,
  Input,
  message,
  Space,
  Checkbox,
  Spin,
  Modal,
  Select, Alert
} from 'antd'
import { PHONE_PATTERN } from '../../constants/general'
import moment from 'moment/moment'
import { v4 as uuidv4 } from 'uuid'
const { Option } = Select

const RequestBidSecurityFees: React.FC = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const [form] = Form.useForm()
  const [showForm, setShowForm] = useState(false)
  const [fullName, setBidderFullName] = useState('')
  const [payment_date, setPaymentDate] = useState('')
  const [token, setToken] = useState('')
  const [isEdit, setIsEdit] = useState(false)
  const { ref_number } = useParams()
  const [loading, setLoading] = useState(false)
  const [declarationChecked, setDeclarationChecked] = useState(false)
  const [loadingRefund, setLoadingRefund] = useState(false)
  const [showOTPForm, setShowOTPForm] = useState(false)
  const [countdown, setCountdown] = useState(300000)
  const [isFormValidated, setIsFormValidated] = useState(true)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [transactionReference, setTransactionReference] = useState<string>('')
  const [otpValue, setOtpValue] = useState('')
  const [otpDigits, setOtpDigits] = useState<string[]>(['', '', '', '', '', ''])
  const [paymentAmount, setPaymentAmount] = useState('')
  const [refNumber, setdecodesValue] = useState<string>('')
  const [showWarningAlert2, setShowWarningAlert2] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [showCancelMessage, setShowCancelMessage] = useState(false)
  const [targetPaymentDateValue, setTargetPaymentDateValue] = useState(false)
  const [showHello, setShowHello] = useState(false)
  const [isVisible, setIsVisible] = useState(true)
  const [selectedBank, setSelectedBank] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [bankCode, setBankCode] = useState('')
  const [biddesRefundStatus, setRefundStatus] = useState()
  const [showInvalidReferenceNumberModal, setShowInvalidReferenceNumberModal] = useState(false)
  const [otpError, setOtpError] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [fullNameForCreateBy, setFullNameForCreateBy] = useState('')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtpValue(e.target.value)
  }

  // OTP input handlers for better UX
  const handleOtpChange = (index: number, value: string): void => {
    if (!/^[0-9]?$/.test(value)) { return }
    const next = [...otpDigits]
    next[index] = value
    setOtpDigits(next)
    setOtpValue(next.join(''))
    setOtpError('')
    const nextInput = document.getElementById(`otp-input-${index + 1}`) as HTMLInputElement | null
    if (value !== '' && nextInput !== null) { nextInput.focus() }
  }

  const handleOtpKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Backspace' && otpDigits[index] === '') {
      const prevInput = document.getElementById(`otp-input-${index - 1}`) as HTMLInputElement | null
      if (prevInput !== null) { prevInput.focus() }
    }
  }

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
    e.preventDefault()
    const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
    if (text.length === 0) { return }
    const filled = Array.from({ length: 6 }, (_, i) => text[i] ?? '')
    setOtpDigits(filled)
    setOtpValue(filled.join(''))
    setOtpError('')
    const lastIndex = Math.min(text.length, 6) - 1
    const nextInput = document.getElementById(`otp-input-${lastIndex}`) as HTMLInputElement | null
    if (nextInput !== null) { nextInput.focus() }
  }

  // Auto-verify OTP when all 6 digits are entered
  useEffect(() => {
    const otpString = otpDigits.join('')
    if (otpString.length === 6 && !loadingRefund && showOTPForm) {
      // Small delay to ensure state is updated
      setTimeout(() => {
        const currentOtp = otpDigits.join('')
        if (currentOtp.length === 6) {
          setOtpValue(currentOtp)
        }
      }, 100)
    }
  }, [otpDigits, loadingRefund, showOTPForm])
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOTPFormCancel = () => {
    setShowOTPForm(false)
    setOtpDigits(['', '', '', '', '', ''])
    setOtpValue('')
    setOtpError('')
  }

  // Handle Resend OTP
  const handleResendOTP = async (): Promise<void> => {
    try {
      setOtpError('')
      setOtpDigits(['', '', '', '', '', ''])
      setOtpValue('')
      setCountdown(300000)
      const payloadOTPForRefund = {
        transaction_reference: transactionReference,
        status: 'PENDING'
      }
      const otpResponse = await InstitutionUserService.createOtpCode(payloadOTPForRefund)
      if (otpResponse.status === 200 || otpResponse.status === 201) {
        void message.success('OTP has been resent to your phone number.')
        const firstInput = document.getElementById('otp-input-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      } else {
        void message.error('Failed to resend OTP. Please try again.')
      }
    } catch (error) {
      void message.error('Failed to resend OTP. Please try again.')
    }
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHello(true)
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  const adjustedPaymentAmount = selectedBank === 'Bank of Kigali Plc'
    ? paymentAmount
    : (Number(paymentAmount) - 1000).toString()

  const handleBankChange = (value: string | undefined): void => {
    const amount = Number(paymentAmount)
    const adjustedAmount = value === 'Bank of Kigali Plc' ? amount : amount - 1000

    // Update selected bank and payment amount
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    setSelectedBank(value)
    form.setFieldsValue({ payment_amount: adjustedAmount })
    setIsModalVisible(true)

    // Map the selected bank to its corresponding code
    let code = ''

    switch (value) {
      case 'Bank of Kigali Plc':
        code = '40'
        break
      case 'BPR Bank Rwanda':
        code = '44'
        break
      case 'Equity Bank Rwanda Plc':
        code = '85'
        break
      case 'Ecobank Rwanda Plc':
        code = '11'
        break
      case 'Guaranty Trust Bank Rwanda Plc':
        code = '70'
        break
      case 'Access Bank Rwanda Plc':
        code = '15'
        break
      case 'Zigama Css':
        code = '75'
        break
      case 'URWEGO OPPORTUNITY BANK PLC':
        code = '45'
        break
      case 'Bank of Africa Rwanda Plc':
        code = '76'
        break
      case 'UNGUKA BANK':
        code = '80'
        break
      case 'AB BANK':
        code = '20'
        break
      case 'I&M Bank Rwanda Plc':
        code = '10'
        break
      case 'Letshego Rwanda Plc':
        code = '21'
        break
      case 'COPEDU Plc':
        code = '27'
        break
      case 'Vision Fund Plc':
        code = '28'
        break
      case 'Compagnie Generale de Banque':
        code = '30'
        break
      case 'National Bank of Rwanda':
        code = '0'
        break
      case 'Development Bank of Rwanda Plc':
        code = '35'
        break
      case 'RIM Ltd':
        code = '32'
        break
      case 'Atlantique Microfinance Plc':
        code = '22'
        break
      case 'Umutanguha Finance Company Plc':
        code = '23'
        break
      case 'Duterimberere-IMF Plc':
        code = '24'
        break
      case 'Goshen Finance Plc':
        code = '26'
        break
      case 'Financial Safety Co Plc':
        code = '29'
        break
      case 'MUGANGA SACCO':
        code = '33'
        break
      case 'Inkunga Finance Plc':
        code = '31'
        break
      case 'Commercial Bank of Africa Rwanda PLC':
        code = '25'
        break
      case 'UMWALIMU SACCO':
        code = '90'
        break
      default:
        code = ''
        break
    }

    // Set bank code in the form
    setBankCode(code)
    form.setFieldsValue({ bank_code: code })
  }

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOk = () => {
    setIsModalVisible(false)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCancel = () => {
    setIsModalVisible(false)
    setShowForm(false)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHello(true)
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOTPSubmit = async () => {
    const otp = (otpDigits.join('') !== '' ? otpDigits.join('') : otpValue)
    if (otp.length !== 6) {
      setOtpError('Please enter the complete 6-digit OTP code')
      return
    }
    setOtpError('')
    setLoadingRefund(true)
    try {
      const respo: any = await InstitutionUserService.verifyOtpForRequestedRefund({
        transaction_reference: transactionReference,
        otp
      })

      if (respo?.status === 200) {
        setShowOTPForm(false)
        setShowSuccessAlert(true)
        setIsFormValidated(true)
        form.resetFields()
      }
    } catch (error: any) {
      if (error?.response?.status === 400) {
        setOtpError(error?.response?.data?.message ?? 'Invalid OTP code. Please try again.')
        setOtpDigits(['', '', '', '', '', ''])
        setOtpValue('')
        const firstInput = document.getElementById('otp-input-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
        void message.warning('Failed To Verify OTP')
      } else {
        setOtpError('An error occurred. Please try again.')
      }
    } finally {
      setLoadingRefund(false)
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 0) {
          clearInterval(timer)
          return 0
        }
        return prevCountdown - 1000
      })
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const fetchData = async () => {
      setLoading(true)
      if (ref_number != null) {
        try {
          const encryptedRefNumber = ref_number
          let trimmedValue = encryptedRefNumber

          // Support both encrypted links and direct/plain reference links.
          try {
            const decodedValue = decodeURIComponent(escape(atob(encryptedRefNumber)))
            if (decodedValue.length > 14) {
              // Encrypted value format: "<random>-<reference>-<random>"
              trimmedValue = decodedValue.substring(7, decodedValue.length - 7)
            }
          } catch {
            // If base64 decode fails, treat URL value as plain transaction reference.
            trimmedValue = encryptedRefNumber
          }

          setdecodesValue(trimmedValue)
          const res = await InstitutionUserService.loadBidsDetailsForRefund(trimmedValue)
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          if (res && res.status === 200) {
            const bidderDetails = res.data
            form.setFieldsValue({
              bidder_full_name: bidderDetails?.bid?.bidder?.full_name,
              bidder_national_id_number: bidderDetails?.bid?.bidder?.nid,
              phone_number: bidderDetails?.bid?.bidder?.phone_number,
              property_id: bidderDetails?.bid?.auction?.property_id,
              transaction_reference: bidderDetails?.ref_number,
              execution_case_number: bidderDetails?.bid?.auction?.execution_case_no,
              bidder_id: bidderDetails?.bid?.bidder.bidder_id,
              bid_security_id: bidderDetails?.payment.bid_security_id,
              email: bidderDetails?.bid?.bidder?.email,
              payment_date: bidderDetails?.payment?.payment_date,
              amount: bidderDetails?.payment?.amount,
              transaction_currency: bidderDetails.payment.currency
            })
            setTransactionReference(bidderDetails?.ref_number)
            setBidderFullName(bidderDetails?.bid?.bidder?.full_name)
            setFullNameForCreateBy(bidderDetails?.bid?.bidder?.full_name ?? '')
            setPaymentDate(bidderDetails?.payment.payment_date)
            setPaymentAmount(bidderDetails?.payment.amount)
            setPhoneNumber(bidderDetails?.bid?.bidder?.phone_number ?? '')
          } else {
            // eslint-disable-next-line no-console
            console.error('Error: Invalid response from server')
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error fetching data:', error)
        } finally {
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    }

    void fetchData()
  }, [ref_number, form])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const onFinish = async (values: any): void => {
    const openOtpModal = (): void => {
      setOtpDigits(['', '', '', '', '', ''])
      setOtpValue('')
      setOtpError('')
      setShowOTPForm(true)
      setCountdown(300000)
      setTimeout(() => {
        const firstInput = document.getElementById('otp-input-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      }, 100)
    }

    setLoadingRefund(true)
    setIsFormSubmitted(true)
    setShowOTPForm(false) // Don't show modal until OTP is created

    // Check if refund request already exists
    try {
      const validationResponse = await InstitutionUserService.validateRefundRequestByRefNumberAndStatus({
        transaction_reference: transactionReference,
        status: 'RECEIVED REQUEST'
      })
      if (validationResponse.data.length > 0) {
        // Refund request exists, show notification modal
        setShowOTPForm(false)
        setShowInvalidReferenceNumberModal(true)
        const refundStatus = validationResponse.data[0].status
        setRefundStatus(refundStatus)
        setLoadingRefund(false)
        return
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error validating refund request:', error)
      // Continue to create OTP even if validation check fails
    }

    // Validate transaction reference exists
    if (transactionReference === '' || transactionReference == null) {
      setLoadingRefund(false)
      void message.error('Transaction reference is required. Please refresh the page and try again.')
      return
    }

    // Create/replace pending refund request first with the form values.
    try {
      const refundableAmountRaw = String(values.payment_amount ?? paymentAmount ?? '')
      const refundableAmount = Number(refundableAmountRaw.replace(/,/g, '').trim())

      if (!Number.isFinite(refundableAmount) || refundableAmount <= 0) {
        setLoadingRefund(false)
        void message.error('Invalid refundable amount. Please re-check selected bank and try again.')
        return
      }

      const payload = {
        RefundRequest: {
          bank_code: values.bank_code ?? bankCode ?? form.getFieldValue('bank_code'),
          transaction_reference: transactionReference,
          debit_account_number: '000400696575429',
          debit_account_name: 'MINIJUST AUCTION FUNDS MAF',
          beneficiary_account_name: values.beneficiary_bank_account_name,
          beneficiary_bank_name: values.beneficiary_bank_name,
          beneficiary_account_number: values.beneficiary_account_number,
          amount: refundableAmount,
          transaction_currency: values.transaction_currency ?? form.getFieldValue('transaction_currency'),
          reason: `Refund of ${values.amount} for ${values.beneficiary_bank_account_name} ${values.bidder_national_id_number}, ${values.phone_number} ${values.execution_case_number} with ${values.property_id}`,
          status: 'PENDING',
          bidder_id: values.bidder_id ?? form.getFieldValue('bidder_id'),
          bid_security_id: values.bid_security_id ?? form.getFieldValue('bid_security_id'),
          phone_number: values.phone_number,
          email: values.email ?? form.getFieldValue('email'),
          created_by: fullNameForCreateBy !== '' ? fullNameForCreateBy : (userInfo?.full_name ?? values.bidder_full_name ?? '')
        }
      }

      const createResponse: any = await InstitutionUserService.TriggerRefundRequest(payload, '')
      const isCreateSuccess =
        createResponse?.status === 201 ||
        createResponse?.code === 201 ||
        createResponse?.status === 200 ||
        createResponse?.code === 200

      if (!isCreateSuccess) {
        setLoadingRefund(false)
        const createMessage = createResponse?.message ?? 'Failed to save refund request details. Please try again.'
        void message.error(createMessage)
        return
      }

      // /refund/add-refund-request already generates and sends an OTP.
      // Open modal immediately so bidder can verify even if refresh endpoint is flaky.
      openOtpModal()
      setLoadingRefund(false)
      void message.success('OTP has been sent to your phone number. Please check your SMS.')

      const payloadOTPForRefund = {
        transaction_reference: transactionReference,
        status: 'PENDING'
      }

      // eslint-disable-next-line no-console
      console.log('Creating OTP with payload:', payloadOTPForRefund)

      const otpResponse = await InstitutionUserService.createOtpCode(payloadOTPForRefund)

      // eslint-disable-next-line no-console
      console.log('OTP Response:', otpResponse)

      if (!(otpResponse.status === 200 || otpResponse.status === 201)) {
        // Continue with the OTP that was already sent by add-refund-request.
      }
    } catch (error: any) {
      setLoadingRefund(false)
      // eslint-disable-next-line no-console
      console.error('OTP Creation Error:', error)

      if (error?.response != null) {
        const status = error.response.status
        const errorData = error.response.data

        if (status === 404) {
          // OTP record might already exist - show modal anyway
          void message.warning('OTP may have already been sent. Please check your phone for the OTP code.')
          setOtpDigits(['', '', '', '', '', ''])
          setOtpValue('')
          setOtpError('')
          setShowOTPForm(true)
          setCountdown(300000)
          // Focus on first input after modal opens
          setTimeout(() => {
            const firstInput = document.getElementById('otp-input-0') as HTMLInputElement | null
            if (firstInput !== null) {
              firstInput.focus()
            }
          }, 100)
        } else if (status === 400) {
          const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'Invalid request. Please verify your transaction reference and try again.'
          void message.error(errorMessage)
        } else if (status === 500) {
          void message.error('Server error occurred while generating OTP. Please try again later.')
        } else {
          const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'Failed to create OTP. Please try again.'
          void message.error(errorMessage)
        }
      } else if (error?.message === 'Network Error' || error?.code === 'ECONNABORTED') {
        void message.error('Network error. Please check your internet connection and try again.')
      } else {
        void message.error('An unexpected error occurred. Please try again or contact support.')
      }
    }
  }
  return (
    <div className="w-full">
      <div className="navbar pay-bot-border navbar-background">
        <div className="flex">
          <div className="nav-logo">
            <img src={minijust_logo} alt="Logo"/>
          </div>
          <div className="nav-content text-sm md:text-2xl">
            <div className="nav-content-header">MINIJUST - IECMS</div>
            <div>Bid Security Online Payment and Refund</div>
          </div>
        </div>
      </div>
      {isVisible && (
        <div className="scrollableContent">
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form p-10"
            initialValues={{ remember: true }}
            autoComplete="off"
            onFinish={onFinish}
            form={form}
          >
            <Space direction="vertical" size={5} className="w-full content-background">
              <Card className="card-border h-full">
                <div
                  className="font-extrabold text-xl flex text-center items-center justify-center leading-10 text-gray-500 pb-2">
                  Please fill the form below for requesting refund
                </div>

                <div
                  className="green-color font-extrabold text-xl flex text-center items-center justify-center py-5">
                  Refund Request Details
                </div>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bidder's National ID Number"
                      name="bidder_national_id_number"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Bidder's National ID Number"
                        }
                      ]}
                    >
                      <Input
                        maxLength={16}
                        placeholder="Enter Bidder's National ID Number" disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Phone Number"
                      name="phone_number"
                      rules={[{
                        required: true,
                        message: 'Please enter Phone Number'
                      },
                        {
                          message: 'Phone number should be either 4 digits or 10 digits.',
                          pattern: PHONE_PATTERN
                        }]}
                    >
                      <Input type='tel' placeholder="Enter Phone Number"
                             disabled/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Property ID"
                      name="property_id"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Property ID'
                        }
                      ]}
                    >
                      <Input placeholder="Enter Property ID" disabled/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Execution Case Number"
                      name="execution_case_number"
                      rules={[{
                        required: true,
                        message: 'Please enter Execution Case Number'
                      }]}
                    >
                      <Input placeholder="Execution Case Number" disabled/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bid Reference Number"
                      name="transaction_reference"
                      rules={[{
                        required: true,
                        message: 'Please enter transaction reference'
                      }]}
                    >
                      <Input placeholder="Bid Reference Number" disabled/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Beneficiary Name"
                      name="bidder_full_name"
                      rules={[{
                        required: true,
                        message: 'Please enter Beneficial Name'
                      }]}
                    >
                      <Input placeholder="Beneficiary Account Name" disabled/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Deposit Bid Security Amount"
                      name="amount"
                      rules={[{
                        required: true,
                        message: 'Please enter Amount'
                      }]}
                    >
                      <Input type='text' placeholder="Amount" disabled/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Currency"
                      name="transaction_currency"
                      rules={[{
                        required: true,
                        message: 'Please provide the transaction currency'
                      }]}
                    >
                      <Input
                        maxLength={24}
                        placeholder="RWF" disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bid Security Payment Date"
                      name="payment_date"
                      rules={[
                        {
                          required: true,
                          message: 'Payment Date not Available'
                        }
                      ]}
                    >
                      <Input placeholder="Bid Payment Date" disabled/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bank Name"
                      name="beneficiary_bank_name"
                      rules={[
                        {
                          required: true,
                          message: "Please select the Bidder's Bank Name"
                        }
                      ]}
                    >
                      <Select placeholder="Select Beneficiary Bank" allowClear
                              onChange={handleBankChange}>
                        <Option value="Bank of Kigali Plc">Bank of Kigali Plc</Option>
                        <Option value="Equity Bank Rwanda Plc">Equity Bank Rwanda Plc</Option>
                        <Option value="BPR Bank Rwanda">BPR Bank Rwanda</Option>
                        <Option value="Ecobank Rwanda Plc">Ecobank Rwanda Plc</Option>
                        <Option value="Guaranty Trust Bank Rwanda Plc">Guaranty Trust Bank Rwanda Plc</Option>
                        <Option value="Access Bank Rwanda Plc">Access Bank Rwanda Plc</Option>
                        <Option value="Zigama Css">Zigama Css</Option>
                        <Option value="URWEGO OPPORTUNITY BANK PLC">URWEGO OPPORTUNITY BANK PLC</Option>
                        <Option value="Bank of Africa Rwanda Plc">Bank of Africa Rwanda Plc</Option>
                        <Option value="UNGUKA BANK">UNGUKA BANK</Option>
                        <Option value="AB BANK">AB BANK</Option>
                        <Option value="I&M Bank Rwanda Plc">I&M Bank Rwanda Plc</Option>
                        <Option value="Letshego Rwanda Plc">Letshego Rwanda Plc</Option>
                        <Option value="COPEDU Plc">COPEDU Plc</Option>
                        <Option value="Vision Fund Plc">Vision Fund Plc</Option>
                        <Option value="Compagnie Generale de Banque">Compagnie Generale de Banque</Option>
                        <Option value="National Bank of Rwanda">National Bank of Rwanda</Option>
                        <Option value="Development Bank of Rwanda Plc">Development Bank of Rwanda Plc</Option>
                        <Option value="RIM Ltd">RIM Ltd</Option>
                        <Option value="Atlantique Microfinance Plc">Atlantique Microfinance Plc</Option>
                        <Option value="Umutanguha Finance Company Plc">Umutanguha Finance Company Plc</Option>
                        <Option value="Duterimberere-IMF Plc">Duterimberere-IMF Plc</Option>
                        <Option value="Goshen Finance Plc">Goshen Finance Plc</Option>
                        <Option value="Financial Safety Co Plc">Financial Safety Co Plc</Option>
                        <Option value="MUGANGA SACCO">MUGANGA SACCO</Option>
                        <Option value="Inkunga Finance Plc">Inkunga Finance Plc</Option>
                        <Option value="UMWALIMU SACCO">UMWALIMU SACCO</Option>
                        <Option value="Commercial Bank of Africa Rwanda PLC">NCBA Bank Rwanda PLC</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Modal
                    title="Refund Notification"
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                  >
                    <p>Selected Bank: <strong>{selectedBank}</strong></p>
                    <p>Amount to be Refunded:<strong>
                      {selectedBank === 'Bank of Kigali'
                        ? paymentAmount
                        : (Number(paymentAmount) - 1000)}
                    </strong>
                    </p>
                    <p><strong>Note:</strong> You will be charged <strong>1000RWF</strong> from Bank to other banks</p>
                  </Modal>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bank Account Number"
                      name="beneficiary_account_number"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Bank Account Number'
                        },
                        {
                          pattern: /^[0-9]+$/,
                          message: 'Please enter only numbers for Bank Account Number'
                        }
                      ]}
                    >
                      <Input
                        maxLength={24}
                        placeholder="Enter Bidder's Bank Account Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bank Account Name"
                      name="beneficiary_bank_account_name"
                      rules={[{
                        required: true,
                        message: 'Please enter Bank Account Name'
                      }]}
                    >
                      <Input type='text' placeholder="Enter Bank Account Name"/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Refundable Amount"
                      name="payment_amount"
                      rules={[{
                        required: true,
                        message: 'Please enter Refundable Amount'
                      }]}
                    >
                      <input
                        type="text"
                        disabled
                        placeholder="Enter Refundable Amount"
                        style={{
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          padding: '8px',
                          width: '100%',
                          boxSizing: 'border-box'
                        }}
                        /* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */
                        value={selectedBank ? adjustedPaymentAmount : paymentAmount}
                        onChange={(e) => { setPaymentAmount(e.target.value) }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      // label="Bank Code"
                      name="bank_code"
                      rules={[{
                        required: true,
                        message: 'Please enter Bank Code'
                      }]}
                    >
                      <input
                        type="text"
                        disabled
                        className="border-none disabled:bg-white disabled:text-white disabled:p-0 font-bold disabled:cursor-default placeholder:hidden"
                        value={bankCode}
                        onChange={(e) => { /* handle any change if needed */ }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={16} xl={16}>
                    <Form.Item name="declaration" rules={[{ required: false }]}>
                      <Checkbox onChange={(e) => {
                        setDeclarationChecked(e.target.checked)
                      }}>
                        I, <b>{fullName}</b>, hereby declare that the provided
                        information about <b>Account Number, Bank Account Name
                        and Bank Name</b> are true, accurate and complete.
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>
                {/* Submit Button */}
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={16} xl={16}>
                    <Form.Item>
                      <Button type="primary" htmlType="submit"
                              disabled={loadingRefund || !declarationChecked}>
                        {isEdit ? 'Update' : 'Continue'}
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row justify="center" align="middle" style={{ height: '100%' }}>
                  <Col xs={24} md={24} xl={24}>
                    {showSuccessAlert && (
                      <Modal
                        visible={showSuccessAlert}
                        onCancel={() => {
                          setShowSuccessAlert(false)
                        }}
                        footer={null}
                        centered
                      >
                        <Alert
                          message="Informational Notes"
                          /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                          description="Refund Request Submitted. Waiting to be Refunded..."
                          type="info"
                          showIcon
                          style={{
                            width: '100%'
                          }} // Set alert background color
                          onClose={() => {
                            setShowSuccessAlert(false)
                          }}
                        />
                      </Modal>
                    )}
                  </Col>
                </Row>

              </Card>
            </Space>
          </Form>
          <Modal
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '24px' }}>🔐</span>
                <span style={{ fontSize: '18px', fontWeight: '600' }}>Enter Verification Code</span>
              </div>
            }
            visible={showOTPForm}
            onCancel={handleOTPFormCancel}
            footer={[
              <Button key="cancel" onClick={handleOTPFormCancel}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => { void handleOTPSubmit() }}
                disabled={otpDigits.join('').length !== 6}
                loading={loadingRefund}
              >
                Verify & Submit
              </Button>
            ]}
            className="custom-modal"
            keyboard={false}
            maskClosable={false}
            width={500}
            style={{ borderRadius: '12px' }}
          >
            <div style={{ padding: '8px 0' }}>
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <p style={{ margin: '0 0 8px 0', color: '#666', fontSize: '14px' }}>
                  We sent a verification code to your phone number ending with{' '}
                  <strong style={{ color: '#1890ff' }}>
                    {phoneNumber.length > 2 ? `****${phoneNumber.slice(-2)}` : '******'}
                  </strong>
                </p>
                <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                  Please enter the 6-digit code below
                </p>
              </div>

              {otpError !== '' && (
                <Alert
                  message={otpError}
                  type="error"
                  showIcon
                  style={{ marginBottom: '20px' }}
                  closable
                  onClose={() => { setOtpError('') }}
                />
              )}

              <Form.Item
                name="otp"
                rules={[{ required: true, message: 'Please enter the complete OTP code' }]}
                style={{ marginBottom: '20px' }}
              >
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '8px' }}>
                  {otpDigits.map((digit, idx) => (
                    <Input
                      key={idx}
                      id={`otp-input-${idx}`}
                      value={digit}
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={1}
                      onChange={(e) => { handleOtpChange(idx, e.target.value) }}
                      onKeyDown={(e) => { handleOtpKeyDown(idx, e) }}
                      onPaste={(e) => { handleOtpPaste(e) }}
                      style={{
                        width: '48px',
                        height: '56px',
                        textAlign: 'center',
                        fontSize: '24px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        borderColor: (otpError !== '') ? '#ff4d4f' : '#d9d9d9',
                        borderWidth: '2px',
                        transition: 'all 0.2s'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#1890ff'
                        e.target.style.boxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)'
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = (otpError !== '') ? '#ff4d4f' : '#d9d9d9'
                        e.target.style.boxShadow = 'none'
                      }}
                    />
                  ))}
                </div>
              </Form.Item>

              <div style={{ textAlign: 'center', marginTop: '24px' }}>
                <p style={{ margin: '0 0 12px 0', color: '#666', fontSize: '13px' }}>
                  Code expires in{' '}
                  <code
                    style={{
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: countdown < 60000 ? '#ff4d4f' : '#1890ff',
                      background: '#f0f0f0',
                      padding: '4px 8px',
                      borderRadius: '4px'
                    }}
                  >
                    {moment(countdown).format('mm:ss')}
                  </code>
                </p>
                <div style={{ marginTop: '16px' }}>
                  {countdown === 0
                    ? (
                        <Button
                          type="link"
                          onClick={() => { void handleResendOTP() }}
                          style={{ padding: '0', fontWeight: '600' }}
                        >
                          Resend Code
                        </Button>
                      )
                    : (
                        <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                          Didn&apos;t receive the code?{' '}
                          <Button
                            type="link"
                            disabled
                            style={{ padding: '0', fontSize: '12px' }}
                          >
                            Resend in {moment(countdown).format('mm:ss')}
                          </Button>
                        </p>
                      )}
                </div>
              </div>

              <div
                style={{
                  marginTop: '20px',
                  padding: '12px',
                  background: '#f0f9ff',
                  borderRadius: '8px',
                  border: '1px solid #bae7ff'
                }}
              >
                <p style={{ margin: '0', fontSize: '12px', color: '#666', lineHeight: '1.5' }}>
                  <strong>💡 Tip:</strong> You can paste the entire 6-digit code at once, or enter each digit
                  individually.
                </p>
              </div>
            </div>
          </Modal>
          <Modal
            title="Notification"
            visible={showInvalidReferenceNumberModal}
            onCancel={() => {
              setShowInvalidReferenceNumberModal(false)
              // setShowCancelMessage(true)
              setShowForm(false)
            }}
            footer={null}
            centered
          >
            {showHello && (
              <>
                <p>
                  The Refund Request already exists with the same reference number: {transactionReference}
                </p>
                <p>
                  Your Request Current Status is: {biddesRefundStatus}
                </p>
              </>
            )}
          </Modal>

          {/* Other Modals */}
          {/* ... */}

          {showCancelMessage && (
            <div className="cancel-message">
              <div className="separator"></div>
              <h3>Thank you for using our services.</h3>
              <div className="separator"></div>
              <p>For any other support, please contact us
                on <strong>iecms-support@minijust.gov.rw</strong>.</p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
export default RequestBidSecurityFees
